<div class="ps-flex-container-col">

  <mat-form-field>
    <mat-label>{{'incidents.createComment.insertComment' | translate}}</mat-label>
    <textarea matInput [(ngModel)]="comment"></textarea>
  </mat-form-field>

  <div>
    <button mat-button color="primary" (click)="dismiss()">
      <mat-icon>cancel</mat-icon>
    </button>
    <button mat-button color="primary" (click)="save()">
      <mat-icon>save</mat-icon>
    </button>
  </div>

</div>
